import { CLEAR_FORGET_PASSWORD, FETCH_FORGET_PASSWORD, SET_FORGET_PASSWORD } from "../actions";

const initialState = {
    forgetPasswordData: null,
    isLoading: false,
    error: null,
};

const forgetPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FORGET_PASSWORD:
            return { ...state, isLoading: true, error: null };

        case SET_FORGET_PASSWORD:
            return { ...state, forgetPasswordData: action.payload, isLoading: false, error: null };

        case CLEAR_FORGET_PASSWORD:
            return { ...state, forgetPasswordData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default forgetPasswordReducer;
